var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternethautdebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "internet_haut_d\\xE9bit",
    "data-name": "internet haut d\\xE9bit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.92,35.45H13.57a4.92,4.92,0,0,0-4.92,4.91v3.93a4.93,4.93,0,0,0,4.92,4.92H50.92a4.92,4.92,0,0,0,4.92-4.92V40.36A4.92,4.92,0,0,0,50.92,35.45Zm2.95,8.84a3,3,0,0,1-2.95,3H13.57a3,3,0,0,1-3-3V40.36a3,3,0,0,1,3-3H50.92a3,3,0,0,1,2.95,3v3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.06,21.68a1,1,0,0,0-1,1V36.43a1,1,0,0,0,2,0V22.67A1,1,0,0,0,43.06,21.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.53,
    cy: 42.33,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.43,
    cy: 42.33,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.33,
    cy: 42.33,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.23,
    cy: 42.33,
    r: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49,41.35H39.13a1,1,0,1,0,0,2H49a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.11,22.67A3,3,0,0,1,41,20.58a1,1,0,1,0-1.39-1.39,4.91,4.91,0,0,0,0,7,1,1,0,0,0,.7.29.94.94,0,0,0,.69-.29,1,1,0,0,0,0-1.39A2.94,2.94,0,0,1,40.11,22.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.53,19.19a1,1,0,1,0-1.39,1.39A2.94,2.94,0,0,1,46,22.67a2.9,2.9,0,0,1-.87,2.08,1,1,0,0,0,0,1.39,1,1,0,0,0,.7.29.94.94,0,0,0,.69-.29,4.91,4.91,0,0,0,0-6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.19,17.8a1,1,0,0,0-1.39-1.39,8.87,8.87,0,0,0,0,12.52,1,1,0,0,0,1.39,0,1,1,0,0,0,0-1.4A6.89,6.89,0,0,1,38.19,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.31,16.41a1,1,0,0,0-1.39,1.39,6.89,6.89,0,0,1,0,9.74,1,1,0,0,0,0,1.39,1,1,0,0,0,.7.28,1,1,0,0,0,.69-.28A8.87,8.87,0,0,0,49.31,16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.41,15A1,1,0,1,0,34,13.63a12.81,12.81,0,0,0,0,18.08,1,1,0,0,0,1.39,0,1,1,0,0,0,0-1.39A10.83,10.83,0,0,1,35.41,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.09,13.63A1,1,0,1,0,50.7,15a10.83,10.83,0,0,1,0,15.3,1,1,0,0,0,0,1.39,1,1,0,0,0,.7.28,1,1,0,0,0,.69-.28A12.79,12.79,0,0,0,52.09,13.63Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternethautdebit);
export default __webpack_public_path__ + "static/media/internethautdebit.1abafc1ac6d0e4cfe8767480ae9a46b1.svg";
export { ForwardRef as ReactComponent };